import { render } from "./RadioComponent.vue?vue&type=template&id=5881ebeb&scoped=true&ts=true"
import script from "./RadioComponent?vue&type=script&lang=ts"
export * from "./RadioComponent?vue&type=script&lang=ts"

import "./_assets/_radio.scss?vue&type=style&index=0&id=5881ebeb&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5881ebeb"]])

export default __exports__